
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import ProfileForm from '@/components/profile/ProfileForm';
import { useAuth } from '@/contexts/auth';

const Profile = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();
  
  if (isLoading) {
    return (
      <div className="container mx-auto py-20 px-4">
        <Card>
          <CardContent className="pt-6">
            <p className="text-center">Loading profile...</p>
          </CardContent>
        </Card>
      </div>
    );
  }
  
  if (!user) {
    navigate('/auth');
    return null;
  }

  return (
    <div className="container mx-auto py-20 px-4 max-w-3xl">
      <Button 
        variant="ghost" 
        onClick={() => navigate('/trips')} 
        className="mb-4"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to My Trips
      </Button>

      <Card className="shadow-md">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">My Profile</CardTitle>
        </CardHeader>
        <CardContent>
          <ProfileForm />
        </CardContent>
      </Card>
    </div>
  );
};

export default Profile;
